module.exports = __webpack_public_path__ + "img/WPS图片6@2x.c694a84a.png";